import React from 'react'
import styles from "./CostumerService.module.css";
import {
    Col
  } from "react-bootstrap";

type TContactInformation = {
  icon: string;
  country: string;
  phones: string[];
};

const contactInformation: TContactInformation[] = [
  {
    icon: 'MX.svg',
    country: 'México',
    phones: [
      'México SKY: 5169 0000 o del interior al 01 55 5169 0000',
      'México VeTV: 4040 6200 en el DF o 01(55)4040 6200 del interior de la República.',
    ],
  },
  {
    icon: 'CRI.svg',
    country: 'Costa Rica',
    phones: ['800 027 2586 (sin costo)', '4001-7449', '0800-052-1539'],
  },
  {
    icon: 'GTM.svg',
    country: 'Guatemala',
    phones: ['Guatemala: 23-76-75-25', 'Desde el interior: 1-800-835-0279'],
  },
  {
    icon: 'NIC.svg',
    country: 'Nicaragua',
    phones: ['7877-7979', '2276-9060'],
  },
  {
    icon: 'SLV.svg',
    country: 'El Salvador',
    phones: ['800-6611.'],
  },
  {
    icon: 'HON.svg',
    country: 'Honduras',
    phones: ['800–2-791-9015', '800-2544-0878.'],
  },
  {
    icon: 'RD.svg',
    country: 'República Dominicana',
    phones: [
      'Santo Domingo : 829-946-5987 / 809-560-9842',
      'Desde el interior : 829-200-1130 / 809-200-1010',
    ],
  },
  {
    icon: 'PA.svg',
    country: 'Panamá',
    phones: ['Local: 833-6675 / 832-3298', '800: 00800-226-0270.'],
  },
];

const CustomerService = () => {
  return (<>
    <div className="w-full">
      <div className={styles["text-sky-gray-120"]}>
        <h1 className={styles["text-center"]+" " +styles["text-3xl"]+" "+ styles["font-medium"]+" "+ styles["tracking-widest"]}>
          Contáctate con Servicio a Clientes
        </h1>
        <div>
          <ul className={ styles["mx-16"] +" "+styles["px-5"] +  " mt-5 space-y-2"}>
            {contactInformation.map(({ icon, country, phones }) => (
              <Col >
                <div className={styles["flex"]}>
                  <div className={styles["px-4"] +" "+ styles["flex"]+" "+styles["justify-end"] +" "+styles["items-start"]}>
                    <img src={`/images/publics/countrys/${icon}`} alt={country} className={styles["w-8"] }/>
                  </div>
                  <div className={styles["flex-1"]}>
                    <h5 className={styles["font-bold"]}>{country}</h5>
                    <ul className={styles["list-disc"]+" "+styles["list-inside"]}>
                      {phones.map((p) => (
                        <li>{p}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </Col>
            ))}
          </ul>
        </div>
      </div>
    </div>
    </>
  );
}

export default CustomerService
